// extracted by mini-css-extract-plugin
module.exports = {"buttonIcon":"styles_buttonIcon__2zrDb","errorColor":"styles_errorColor__3dg1u","moreButton":"styles_moreButton__2m-mF"};